<template>
  <div class="default-layout">
    <router-view />
  </div>
</template>